import React from 'react'

import { useField } from 'formik'

import Input from '../components/Input'
import Label from '../components/Label'
import FieldProps from './FieldProps'
import Error from './FormItemError'

import './FormikStyles.less'

export interface InputProps extends FieldProps {
  size?: 'large' | 'default' | 'small'
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>
  disabled?: boolean
  defaultValue?: string
  prefix?: React.ReactNode
  suffix?: React.ReactNode
  hint?: string
  maxLength?: number
}

const FormikStyledInputField: React.FC<InputProps | any> = (props) => {
  const [field, meta] = useField(props)
  const showError = meta.touched && meta.error
  const error = showError ? <Error>{meta.error}</Error> : <Error></Error>
  const id = props.id || props.name

  const hint = props.hint ? <span className="formik-field__span"> {props.hint}</span> : null

  return (
    <>
      <div className={`formik-field ${props.disabled ? 'disabled-formik-field' : ''}`}>
        <div
          className={`${props.disabled ? 'disabled-input-wrapper' : 'input-wrapper'} ${
            showError ? 'input-wrapper_with_error' : ''
          }`}
        >
          <Label htmlFor={id} className="formik-field__input-label no-select hand-on-hover">
            {props.label}
            {props.optional && <span className={'field-optional'}> (optional)</span>}
            {hint}
          </Label>
          <Input className={`formik_input input__no-autofill-color ${props.className}`} id={id} {...field} {...props} />
        </div>
      </div>
      {error}
    </>
  )
}
export { FormikStyledInputField as StyledInput }
export default FormikStyledInputField
